import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { STAGES, PRIORITY_LEVELS } from '@/utils/constants';

export function TaskWorkflowTab({ formData, onChange, canEdit }) {
  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold mb-4">Workflow</h3>
        <div className="grid grid-cols-3 gap-6">
          <div>
            <Label htmlFor="stage">Stage</Label>
            <select id="stage" value={formData.stage} onChange={e => onChange('stage', e.target.value)} disabled={!canEdit} className="mt-2 w-full h-10 px-3 border rounded-md bg-white">
              <option value="">Select</option>
              {STAGES.map(s => <option key={s.value} value={s.value}>{s.label}</option>)}
            </select>
          </div>
          <div>
            <Label htmlFor="priority">Priority</Label>
            <select id="priority" value={formData.priority} onChange={e => onChange('priority', e.target.value)} disabled={!canEdit} className="mt-2 w-full h-10 px-3 border rounded-md bg-white">
              {PRIORITY_LEVELS.map(p => <option key={p.value} value={p.value}>{p.label}</option>)}
            </select>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-6">
        <div><Label htmlFor="start_date">Start Date</Label><Input id="start_date" type="date" value={formData.start_date} onChange={e => onChange('start_date', e.target.value)} disabled={!canEdit} className="mt-2" /></div>
        <div><Label htmlFor="target_date">Target Date</Label><Input id="target_date" type="date" value={formData.target_date} onChange={e => onChange('target_date', e.target.value)} disabled={!canEdit} className="mt-2" /></div>
      </div>
      <div className="border-t pt-6 space-y-4">
        <div><Label htmlFor="notes">Notes</Label><Textarea id="notes" value={formData.notes} onChange={e => onChange('notes', e.target.value)} disabled={!canEdit} className="mt-2" rows={3} /></div>
        <div><Label htmlFor="special_instructions">Special Instructions</Label><Textarea id="special_instructions" value={formData.special_instructions} onChange={e => onChange('special_instructions', e.target.value)} disabled={!canEdit} className="mt-2" rows={3} /></div>
        <div><Label htmlFor="client_feedback">Client Feedback</Label><Textarea id="client_feedback" value={formData.client_feedback} onChange={e => onChange('client_feedback', e.target.value)} disabled={!canEdit} className="mt-2" rows={3} /></div>
      </div>
    </div>
  );
}
